export function findElement(id: string) {
    var selectedElement = document.getElementById(id);
    return selectedElement;
}

//OBS om det behövs border Radius i elementCSS skriv som "border-radius" FOCUS PÅ ("") : "20%"
// elementCSS obj {CSSerty : "red"}

//type = {href:link}/{class:ClassName} Skall också skickas som object , då kan man ange
//mer specifika parametrar t.ex. till ett <a> eller så

export function createElement(elementName: string, attributes: any, style: any) {
    var element = document.createElement(elementName) as any;
    for (var key in attributes) {
        element.setAttribute(key, attributes[key]);
    }
    for (var key in style) {
        element.style[key] = style[key];
    }
    return element;
}

export function textContent(content: string) {
    return document.createTextNode(content);
}

export function appendOnBody(element: any) {
    document.body.appendChild(element);
}

export function appendToElement(el: string, element: any) {
    var a = document.getElementById(el);
    if (!!a) {
        a.appendChild(element);
    }
}

export function removeElement(elementId: string) {
    var element = document.getElementById(elementId);

    var body = document.body;

    if (!!body && !!element) {
        body.removeChild(element);
    }

    //ogiltig argument
}
